import type Style from "@components/HomePage/Cards/model/Style";
import type { ItemType } from "@core/FileStructue/Item/ItemType";
import type { ClientItemRef } from "@core/SitePresenter/SitePresenter";
import type { PropertyID } from "@ext/properties/models";
import type { FileStatus } from "@ext/Watchers/model/FileStatus";

export interface NavigationGroupLevel {
	id: PropertyID;
	values: string[];
}

export interface ItemLinkOptions {
	usesCatalogTemplate?: boolean;
	isHasErrorCode?: boolean;
	grouping?: NavigationGroupLevel[];
}

export type CatalogLinkStatus =
	| "ready"
	| "unpublished"
	| "broken"
	| "cloning"
	| "space-cloning"
	| "clone-failed"
	| "not-loaded";

export const isCloningStatus = (status: string | undefined): boolean =>
	status === "cloning" || status === "space-cloning";

export const isNotLoadedStatus = (status: string | undefined): boolean =>
	status === "not-loaded" || status === "space-cloning";

export interface CatalogLink extends BaseLink {
	name: string;
	logo: string;
	logoDark?: string;
	title: string;
	style: Style;
	group: string;
	order: number;
	description: string;
	lastVisited?: string;
	status: CatalogLinkStatus;
	cloneCancelDisabled?: boolean;
	redirectOnClone?: string;
	isFavorite?: boolean;
	repo?: string;
	branch?: string;
}

export interface BaseLink {
	pathname: string;
	query?: { [name: string]: string };
	hash?: string;
}

export interface ItemLink extends BaseLink {
	treeId?: string;
	type: ItemType;
	title: string;
	fileName: string;
	icon: string;
	isCurrentLink: boolean;
	ref: ClientItemRef;
	external?: string;
	status?: FileStatus;
	options?: ItemLinkOptions;
}

export interface CategoryLink extends ItemLink {
	type: ItemType.category;
	items: (ItemLink | CategoryLink)[];
	isExpanded: boolean;
	filter?: LinkFilter;
	existContent?: boolean;
}

export interface ArticleLink extends ItemLink {
	type: ItemType.article;
	alwaysShow?: boolean;
}

export interface LinkFilter {
	top?: number;
	last?: number;
}

export interface TitledLink {
	url?: string;
	title?: string;
	icon?: string;
	target?: "_self" | "_blank" | "_parent" | "_top";
	private?: boolean;
	onClick?: () => void;
	childrens?: TitledLink[];
}
